import script from "./ConsumerLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerLayout.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerLayout.vue?vue&type=style&index=0&id=20db4f94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20db4f94"]])

export default __exports__